module.exports = __webpack_public_path__ + "img/wefwef.f8c78c0d.png";